'use client';

import { sendInterest } from '@eliadmin/core/src/api/interests/interests-api';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useToast } from '@eliadmin/core/src/components/ui/use-toast';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { useState } from 'react';
import { FiCheck } from 'react-icons/fi';

type SendInterestOffer = {
  id: number;
  isSentInterest: boolean;
};

export const SendInterestButton = ({ offer }: { offer: SendInterestOffer }) => {
  const { t } = useTranslations();
  const locale = useLocaleStore(state => state.currentLocale);

  const me = useCustomerStore(state => state.me);
  const { toast } = useToast();

  const [isSentInterest, setIsSentInterest] = useState(offer.isSentInterest);
  const handleJobOfferReaction = () => {
    if (!me || !me.authToken) {
      toast({
        title: t('Nie ste prihlásený/á'),
        variant: 'destructive',
        duration: 5000,
      });
      return;
    }

    try {
      sendInterest({
        data: {
          ...me?.customer,
          offer: {
            id: offer.id,
          },
        },
        authToken: me?.authToken,
        locale,
      })
        .then(() => {
          toast({
            title: t('Záujem bol úspešne odoslaný'),
            variant: 'success',
            duration: 5000,
          });
          setIsSentInterest(true);
        })
        .catch(() => {
          toast({
            title: t('Nastala chyba'),
            description: t('Záujem o pracovnú ponuku už bol realizovany.'),
            variant: 'destructive',
            duration: 5000,
          });
          setIsSentInterest(true);
        });
    } catch (error) {
      toast({
        title: t('Nastala chyba'),
        description: t('Záujem o pracovnú ponuku už bol realizovany.'),
        variant: 'success',
        duration: 5000,
      });
      setIsSentInterest(true);
    }
  };

  if (isSentInterest)
    return (
      <Button className="flex w-full gap-2">
        <FiCheck className="h-5 w-5 text-white" />
        Záujem bol zaslaný
      </Button>
    );
  return (
    <Button className="w-full" onClick={() => handleJobOfferReaction()}>
      {t('text887')}
    </Button>
  );
};
